import { Circle, G, Path, Rect, Svg } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The TaskScribe logomark. Generated from the same geometry as the app
 * icon and the website favicon, so the three surfaces cannot drift apart.
 * Colours are the brand's own — a mark should not follow semantic tokens.
 */
const schemes = {
  light: { plate: "#ffffff", ink: "#111111", accent: "#111111" },
  dark: { plate: "#0d0d0d", ink: "#f2f2f2", accent: "#f2f2f2" },
} as const;

export function Logomark({ size = 26 }: { size?: number }) {
  const { scheme } = useTheme();
  const c = schemes[scheme === "dark" ? "dark" : "light"];
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      accessibilityLabel="TaskScribe"
    >
      <Rect x="10" y="10" width="12" height="12" rx="1.5" fill={c.ink} />
      <Rect
        x="27"
        y="11"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect
        x="43"
        y="11"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect
        x="11"
        y="27"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect x="26" y="26" width="12" height="12" rx="1.5" fill={c.ink} />
      <Rect
        x="43"
        y="27"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect
        x="11"
        y="43"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect
        x="27"
        y="43"
        width="10"
        height="10"
        rx="1"
        fill="none"
        stroke={c.ink}
        strokeWidth="2"
      />
      <Rect x="42" y="42" width="12" height="12" rx="1.5" fill={c.ink} />
      <Path
        d="M45 48.5 L47.6 51 L51.5 45.8"
        fill="none"
        stroke={c.plate}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
